module.exports = __webpack_public_path__ + "static/media/back_06.600454fe.png";